module.exports = __webpack_public_path__ + "img/biztositas-javitas.d825ed4b.png";